import React from "react";
import ReactDOM from "react-dom";
import { NavBar } from "./components/header";
import { snakeToCamelCase } from "./utils/snakeToCamelCase";
import { NavBarProps } from "./components/header/NavBar";

const container = $("#navbar-top").get(0) as HTMLElement;
const {
    patient_app_context = {},
    formatted_phone_call_inbound,
    provider_business_unit_logo,
    provider_name,
} = cedar.serverDataGlobal;
const patientAppContext = snakeToCamelCase(patient_app_context);

const isSuppressed = Object.keys(patientAppContext).length === 0;

const navBarProps = {
    formattedPhoneCallInbound: formatted_phone_call_inbound,
    providerBusinessUnitLogoSrc: provider_business_unit_logo,
    providerName: provider_name,
    isSuppressed,
    ...patientAppContext,
} as NavBarProps;
ReactDOM.render(<NavBar {...navBarProps} />, container);
